import { FrownOutlined } from "@ant-design/icons";
import { notification } from "antd";

async function useMobileAppUserDelete(useMobileAppUserDeleteMutation, user) {
  let deleteUserResponse;
  try {
    deleteUserResponse = await useMobileAppUserDeleteMutation.mutateAsync(
      user?.Email,
    );
    notification.success({
      message: <span className="uppercase tracking-widest">user deleted</span>,
      duration: 2,
      placement: "topRight",
    });
  } catch (error) {
    notification.error({
      message: (
        <span className="uppercase tracking-widest">Something went wrong!</span>
      ),
      duration: 5,
      description: "Could Not Delete User.",
      placement: "topRight",
      icon: <FrownOutlined className="text-triple-red" />,
    });
  }

  return deleteUserResponse;
}
export default useMobileAppUserDelete;
